
import { ButtonStyledGroup } from './styled';

import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BtnGroup',
  components: {
    ButtonStyledGroup,
  },
});
